import { render, staticRenderFns } from "./FreightTemplatePage.vue?vue&type=template&id=6cd8892f&scoped=true"
import script from "./FreightTemplatePage.vue?vue&type=script&lang=js"
export * from "./FreightTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./FreightTemplatePage.vue?vue&type=style&index=0&id=6cd8892f&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd8892f",
  null
  
)

export default component.exports